import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import classNames from "classnames";
import { ISOToDisplayCode } from "@utils";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { THEME_SETTINGS } from "@theme-settings";

export default observer(function AutosellButton() {
	const bet = useContext(MyBetsBetContext);
	const store = useContext(MyBetsStoreContext);

	if (store == null) {
		console.error("Expected store, got null.");
		return null;
	}

	const { t } = useTranslation("mybets");

	if (!WEBPACK_IS_AUTOCASHOUT_ENABLED) {
		return null;
	}

	const autoCashoutButtonClasses = classNames(
		"card--bet__btn card--bet__btn--auto btn btn--sml btn--primary--subtle btn--icon",
		{
			"card--bet__btn--auto-set": bet.isAutoCashoutSet ? true : false,
		}
	);

	const autoCashoutIconClasses = classNames("u-icon u-icon--sml", {
		"u-icon--settings": !bet.isAutoCashoutSet,
		"u-icon--set-stake": bet.isAutoCashoutSet,
	});

	if (
		WEBPACK_IS_AUTOCASHOUT_ENABLED &&
		bet.displayedAmount !== undefined &&
		bet.displayedAmount !== null &&
		bet.displayedAmount !== "0.00"
	) {
		return (
			<button
				type="button"
				className={autoCashoutButtonClasses}
				onClick={() => store.cashoutStore.openAutosellModal(bet)}
			>
				<i className={autoCashoutIconClasses} />
				<span className="btn__label">
					{t("CASHOUT.AUTO_CASHOUT")}{" "}
					{bet.isAutoCashoutSet && bet.betSlipSecureWinSetting != null
						? `${bet.betSlipSecureWinSetting.threshold.toFixed(
								2
							)} ${ISOToDisplayCode(
								THEME_SETTINGS.defaultCurrency
							)}`
						: ""}
				</span>
			</button>
		);
	} else {
		return null;
	}
});
